/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconGraphql = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      fill={fill}
      viewBox="0 0 24 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M11.94 21.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5zm0-20.5a1.75 1.75 0 1 1 0 3.498 1.75 1.75 0 0 1 0-3.498zm9.19 4.948a1.75 1.75 0 1 1 0 3.499 1.75 1.75 0 0 1 0-3.499zm-18.38 0a1.75 1.75 0 1 1 0 3.499 1.75 1.75 0 0 1 0-3.499zm18.38 10.604a1.75 1.75 0 1 1 0 3.499 1.75 1.75 0 0 1 0-3.499zm-18.38 0a1.75 1.75 0 1 1 0 3.499 1.75 1.75 0 0 1 0-3.499z"
        clipRule="evenodd"
      />
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M10.543 3.828l-6.008 3.18m8.836-3.18l6.009 3.18m-9.19 15.553C7.843 21.32 4.535 19.38 4.535 19.38m9.19 3.181l5.655-3.181m-14.845-.707H19.38M2.767 9.483v7.07m18.38-7.07v7.07M12.664 4.535l7.423 12.37M11.25 4.535l-7.422 12.37"
      />
    </svg>
  ),
);
